/* ═══════════════════════════════════════════════════
   Quiet Dose — Global JavaScript
   Lägg till i theme.liquid precis före </body>:
   {{ 'quietdose.js' | asset_url | script_tag }}
   ═══════════════════════════════════════════════════ */

(function(){
  'use strict';

  /* 1. Scroll Reveal */
  var els = document.querySelectorAll('[data-r]');
  if (els.length) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    var sections = {};
    els.forEach(function(el) {
      var sec = el.closest('section, footer, header') || document.body;
      var id = sec.id || sec.tagName;
      if (!sections[id]) sections[id] = [];
      sections[id].push(el);
    });
    Object.values(sections).forEach(function(group) {
      group.forEach(function(el, i) {
        el.style.transitionDelay = (i * 0.06) + 's';
        obs.observe(el);
      });
    });
  }

  /* 2. Hamburger menu */
  var burger = document.getElementById('navBurger');
  var mobileMenu = document.getElementById('navMobile');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.contains('open');
      mobileMenu.classList.toggle('open', !isOpen);
      burger.classList.toggle('open', !isOpen);
      burger.setAttribute('aria-expanded', String(!isOpen));
    });
    mobileMenu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        mobileMenu.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* 3. Sticky CTA — dölj över hero och subscribe */
  var stick = document.getElementById('stickyCta');
  var hero = document.getElementById('hero');
  var subscribe = document.getElementById('subscribe');
  var heroVisible = true;
  var subscribeVisible = false;
  function updateStick() {
    if (!stick) return;
    var show = !heroVisible && !subscribeVisible;
    stick.classList.toggle('vis', show);
  }
  if (stick && hero) {
    new IntersectionObserver(function(e) { heroVisible = e[0].isIntersecting; updateStick(); }, { threshold: 0 }).observe(hero);
  }
  if (stick && subscribe) {
    new IntersectionObserver(function(e) { subscribeVisible = e[0].isIntersecting; updateStick(); }, { threshold: 0 }).observe(subscribe);
  }

  /* 4. Aktiv nav-länk vid scroll */
  var links = document.querySelectorAll('.nav-lnk[data-s]');
  var sects = {};
  links.forEach(function(l) {
    var sec = document.getElementById(l.getAttribute('href').slice(1));
    if (sec) sects[l.getAttribute('data-s')] = sec;
  });
  Object.values(sects).forEach(function(s) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          links.forEach(function(l) { l.classList.remove('act'); });
          links.forEach(function(l) { if (sects[l.getAttribute('data-s')] === e.target) l.classList.add('act'); });
        }
      });
    }, { threshold: 0.3 }).observe(s);
  });

  /* 5. FAQ Accordion */
  document.querySelectorAll('.faq-item').forEach(function(item) {
    var btn = item.querySelector('.faq-btn');
    var ans = item.querySelector('.faq-ans');
    if (!btn || !ans) return;
    var id = 'faq-' + Math.random().toString(36).substr(2, 6);
    ans.id = id;
    btn.setAttribute('aria-controls', id);
    btn.addEventListener('click', function() {
      var open = item.classList.contains('open');
      if (open) {
        ans.style.maxHeight = ans.scrollHeight + 'px';
        requestAnimationFrame(function() { ans.style.maxHeight = '0px'; });
        item.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        ans.style.maxHeight = ans.scrollHeight + 'px';
        ans.addEventListener('transitionend', function h() {
          if (item.classList.contains('open')) ans.style.maxHeight = 'none';
          ans.removeEventListener('transitionend', h);
        });
      }
    });
  });

  /* 6. Sifferräknare i problemsektionen */
  var statEl = document.querySelector('.prob-stat-n');
  if (statEl) {
    var target = parseInt(statEl.getAttribute('data-target')) || 60;
    var started = false;
    new IntersectionObserver(function(e) {
      if (e[0].isIntersecting && !started) {
        started = true;
        var start = performance.now();
        function tick(now) {
          var p = Math.min((now - start) / 1400, 1);
          statEl.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + '%';
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.2 }).observe(statEl);
  }

  /* 7. INCI Modal */
  var inciBtn = document.getElementById('inciBtn');
  var inciOverlay = document.getElementById('inciOverlay');
  var inciClose = document.getElementById('inciClose');
  function openInci() { inciOverlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeInci() { inciOverlay.classList.remove('open'); document.body.style.overflow=''; }
  if (inciBtn) inciBtn.addEventListener('click', openInci);
  if (inciClose) inciClose.addEventListener('click', closeInci);
  if (inciOverlay) inciOverlay.addEventListener('click', function(e){ if(e.target===inciOverlay) closeInci(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeInci(); });

})();
